'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import React from 'react';

function AbstractElement(_ref) {
  var children = _ref.children,
      tagName = _ref.tagName,
      rest = _objectWithoutProperties(_ref, ["children", "tagName"]);

  var Tag = tagName;
  return React.createElement(Tag, rest, children);
}

AbstractElement.propTypes = {
  children: PropTypes.node,
  tagName: PropTypes.string.isRequired
};
AbstractElement.defaultProps = {
  tagName: 'span'
};
AbstractElement.displayName = 'AbstractElement';
export default AbstractElement;